import { styled } from "styled-components";

export const LinkCategoriesContainer = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    align-items: flex-start;
    max-height: 100%;
    padding: 12px;
    overflow: auto;
    max-width: 100%;
  }
`;
